import { render, staticRenderFns } from "./CutSheetEditor.vue?vue&type=template&id=5b8557e8&scoped=true"
import script from "./CutSheetEditor.vue?vue&type=script&lang=js"
export * from "./CutSheetEditor.vue?vue&type=script&lang=js"
import style0 from "./CutSheetEditor.vue?vue&type=style&index=0&id=5b8557e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8557e8",
  null
  
)

export default component.exports